import type { SpanNode } from "@/types/spans";
import { routePaths } from "@/utils/routePaths";

const TABLE_ID_KEYS = ["table_id", "pl.table_id", "eval.table_id"] as const;
const SHEET_ID_KEYS = ["sheet_id", "pl.sheet_id", "eval.sheet_id"] as const;

const getAttributeId = (
  attributes: Record<string, unknown> | null | undefined,
  keys: readonly string[],
): string | null => {
  if (!attributes) {
    return null;
  }

  for (const key of keys) {
    const value = attributes[key];
    if (typeof value === "number" && Number.isFinite(value)) {
      return String(value);
    }
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
  }

  return null;
};

const findTableSheetIds = (
  nodes: SpanNode[] | null | undefined,
): { tableId: string; sheetId: string } | null => {
  if (!nodes?.length) {
    return null;
  }

  for (const node of nodes) {
    const tableId = getAttributeId(node.attributes, TABLE_ID_KEYS);
    const sheetId = getAttributeId(node.attributes, SHEET_ID_KEYS);
    if (tableId && sheetId) {
      return { tableId, sheetId };
    }

    const fromChildren = findTableSheetIds(node.children);
    if (fromChildren) {
      return fromChildren;
    }
  }

  return null;
};

export const getTraceTableLink = (
  workspaceId: number | string | undefined,
  spanTree: SpanNode[] | null | undefined,
): string | null => {
  if (workspaceId === undefined || workspaceId === null || workspaceId === "") {
    return null;
  }

  const ids = findTableSheetIds(spanTree);
  if (!ids) {
    return null;
  }

  return `${routePaths.workspaceSmartTable(workspaceId, ids.tableId)}?sheet=${ids.sheetId}`;
};
